import * as React from "react";
const SvgFiRrCommentSmile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-smile_svg__a)">
      <path
        fill="#062147"
        d="M16.713 13.804a.996.996 0 0 1-.01 1.406C16.63 15.283 14.864 17 12 17s-4.63-1.716-4.704-1.79a1 1 0 1 1 1.408-1.42C8.75 13.833 9.984 15 12 15s3.25-1.167 3.302-1.216a1 1 0 0 1 1.41.02M8.5 11a1.5 1.5 0 1 0-.001-3 1.5 1.5 0 0 0 0 3m7-3a1.5 1.5 0 1 0 0 3.002A1.5 1.5 0 0 0 15.5 8m8.5 4.34V19c0 2.757-2.243 5-5 5h-5.917C6.082 24 .47 19.208.029 12.854a12.03 12.03 0 0 1 3.479-9.333A12.05 12.05 0 0 1 12.836.03C19.096.454 24 5.861 24 12.34m-2 0c0-5.43-4.085-9.962-9.3-10.316a10.015 10.015 0 0 0-7.778 2.91 10.02 10.02 0 0 0-2.897 7.782c.372 5.38 5.023 9.285 11.058 9.285H19c1.654 0 3-1.346 3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-smile_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentSmile;
